<template>
    <div class="h100">
        <IScroll @loadBottom="loadMore" ref="scroll" id="scrollWrap">
            <slot name="title"></slot>
            <div class="mt10 ml5 mr5">
                <div class="goodInfoBoxList flexBetween">
                    <div class="indexGoodBlock_damai mb5 flexBox-cell-48 rel" v-for="(item,index) in list"
                         :key="index">
                        <div :class="{'goodInfoBlockTip1':styleName === 'main','goodInfoBlockTip2':styleName === 'main_b','goodInfoBlockTip3':styleName === 'main_c'}">
                            TOP<br>{{index+1}}
                        </div>

                        <GoodsListItem :style-name="styleName" :goods-data="item" />
                    </div>
                </div>
            </div>
        </IScroll>
        <div class="goTopBtn">
            <img v-if="topStatus" src="@/assets/images/backTop.png" v-on:click="toTop">
        </div>
    </div>
</template>

<script>
    import IScroll from '../../components/IScroll';
    import GoodsListItem from './TopGoodsListItem';

    export default {
        components: {IScroll, GoodsListItem},
        props: {
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            },
            isMore: {
                type: Boolean,
                default: true
            },
            isTop: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                btnFlag: false
            }
        },
        computed: {
            topStatus() {
                return this.btnFlag && this.isTop;
            },
        },
        updated() {
            document.getElementById('scrollWrap').addEventListener('scroll', this.scrollToTop)
        },
        methods: {
            loadMore: function () {
                this.$emit('loadMore', true);
            },
            scrollToTop: function () {
                this.btnFlag = document.getElementById('scrollWrap').scrollTop > 180;
            },
            toTop: function () {
                this.$refs.scroll.toTop(0);
            }
        }
    }
</script>

<style scoped>

</style>
